var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{staticClass:"Button",attrs:{"fab":"","large":"","icon":"","color":"#ffffff","href":_vm.href,"to":_vm.to}},[_c('div',[_vm._t("icon")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }